import React from 'react'
// containers
import PowerBIReportsContainer from 'containers/PowerBIReports'

const PowerBIReportsPage: React.FC = () => <PowerBIReportsContainer />

export default PowerBIReportsPage
